import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuth } from '@/contexts/AuthContext';
import { Lock } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_research-hub-218/artifacts/lk2wm99x_Skoop%21%20Logo%20-%202026.jpg";

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[calc(100vh-80px)] flex items-center justify-center bg-[#F8FAFC] py-16 px-4">
      <div className="w-full max-w-md">
        <div className="neo-card p-8 sm:p-10">
          <div className="text-center mb-8">
            <img src={LOGO_URL} alt="SKOOP!" className="h-20 w-auto mx-auto mb-4" />
            <h1 className="text-2xl font-black text-[#0A192F]" style={{ fontFamily: 'Outfit, sans-serif' }}>Admin Login</h1>
            <p className="text-sm text-[#475569] mt-1">Sign in to manage SKOOP!</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="admin_email" className="text-sm font-semibold text-[#0A192F] mb-1.5 block">Email</Label>
              <Input
                id="admin_email"
                type="email"
                data-testid="admin-email-input"
                className="neo-input h-12"
                placeholder="admin@skoop.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <Label htmlFor="admin_password" className="text-sm font-semibold text-[#0A192F] mb-1.5 block">Password</Label>
              <Input
                id="admin_password"
                type="password"
                data-testid="admin-password-input"
                className="neo-input h-12"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {error && (
              <div data-testid="admin-login-error" className="p-4 rounded-lg text-sm font-medium bg-[#DC2626]/10 text-[#DC2626] border-2 border-[#DC2626]">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit-btn"
              className="neo-btn w-full py-3.5 bg-[#0A192F] text-white text-base flex items-center justify-center gap-2 disabled:opacity-50"
            >
              <Lock size={18} />
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
